const sameColors = {
  mainTextColor: '#000',
  counterBgColor: '#000',
  counterTimerColor: '#FFF',
};

export const colors = {
  primary: {
    mainBgColor: 'linear-gradient(54.54deg, #0093DC -1.26%, #00C9EF 20.73%, #00E7F9 95.85%)',
    ...sameColors,
  },
  secondary: {
    mainBgColor: '#202227',
    mainTextColor: '#FFF',
    counterBgColor: '#00E7F9',
    counterTimerColor: '#000',
  },
  danger: {
    mainBgColor: '#E1364D',
    ...sameColors,
  },
  warning: {
    mainBgColor: '#FFD043',
    ...sameColors,
  },
};
